import { render } from "./order_top10_report.vue?vue&type=template&id=2c57e5e9"
import script from "./order_top10_report.vue?vue&type=script&lang=js"
export * from "./order_top10_report.vue?vue&type=script&lang=js"

import "./order_top10_report.vue?vue&type=style&index=0&id=2c57e5e9&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__